/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var BroadcastLinkIcon = createIcon("BroadcastLinkIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#171717';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "m4.719 11.28 6.562-6.562M5.334 8.013a2.795 2.795 0 00-2.135.813l-1.406 1.406a2.813 2.813 0 103.977 3.977l1.406-1.406c.563-.564.859-1.34.813-2.136m2.677-2.682a2.796 2.796 0 002.135-.812l1.406-1.407A2.812 2.812 0 0010.23 1.79L8.824 3.195a2.797 2.797 0 00-.81 2.136",
    stroke: _color,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}, {
  "replaceColor": true
});